<div class="thirdLevelNav" *ngIf="child && child.children && showNav">
    <ul class="layouts level-2">
        <ng-container *ngFor="let thirdLevel of child.children">
            <li class="open" [hidden]="thirdLevel.hideDefault && !isExtendedHours">
                <span class="open" *ngIf="thirdLevel.istitle=='true'; else noTitle">
                    {{ thirdLevel.name | pershingTranslate}}
                </span>
                <ng-template #noTitle>
                    <a id="nav-{{thirdLevel.id}}" href="javascript:void(0);" (click)="handleThirdLevelNavigation(thirdLevel)" class="open">
                        {{ thirdLevel.name | pershingTranslate}}
                    </a>
                </ng-template>
            </li>
        </ng-container>
    </ul>
</div>
<div *ngIf="grandChild && !grandChild.hideBack" class="fw-ThirdLevelNavigation_BackLink">
    <a class="fa fa-chevron-left margin-bottom-10" href="javascript: void(0);" (click)="handleBackNavigation()">
        {{ 'NXI_NAVIGATION.BACK' | pershingTranslate}}
    </a>
</div>
